export const LEGAL_VERSIONS = {
  terms: '2025-11-09',
  privacy: '2025-11-09',
};


